import { cn } from "@/lib/utils"

export function WBSection({
  title,
  children,
  id,
  className,
}: {
  title?: React.ReactNode
  children?: React.ReactNode
  id?: string
  className?: string
}) {
  return (
    <section
      id={id}
      className={cn(
        "scroll-mt-20 border-b-2 p-4 last:border-b-0 sm:p-6 md:p-10 lg:p-12",
        className
      )}
    >
      {title && (
        <div className="mb-6 flex items-center gap-3">
          <span className="bg-brand h-3 w-3 flex-shrink-0 border" />
          <h2 className="wb-h4">{title}</h2>
        </div>
      )}

      {children && <div>{children}</div>}
    </section>
  )
}
